export default "/images/reminder.webp"